import { render, staticRenderFns } from "./hotspot_echo.vue?vue&type=template&id=85b4ff4c&scoped=true"
import script from "./hotspot_echo.vue?vue&type=script&lang=js"
export * from "./hotspot_echo.vue?vue&type=script&lang=js"
import style0 from "./hotspot_echo.vue?vue&type=style&index=0&id=85b4ff4c&prod&scoped=true&lang=scss"
import style1 from "./hotspot_echo.vue?vue&type=style&index=1&id=85b4ff4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b4ff4c",
  null
  
)

export default component.exports